export enum PaginationEnum {
	page = 1,
	limit = 6,
}
